import 'react-app-polyfill/ie9';
import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
// import logo from './logo.svg';
// import './App.css';
import 'bootstrap-css-only/css/bootstrap.css';

import { OpenInput, CloseInput, Reference, Change } from './page/input';
import { OpenComplete, CloseComplete, ChangeComplete, CancelComplete } from './page/complete';
import Certification from './page/certification';
import Original from './page/original';

import config from 'Config';
const { root } = config.path;

const NotFound = () => (
  <div className="my-5">
    <h1>お探しのページは見つかりませんでした。</h1>
  </div>
);

const OriginalContext = React.createContext();
const Home = () => {
  return (
    <OriginalContext.Consumer>
      {(original) => <Original original={original} className="App" />}
    </OriginalContext.Consumer>
  );
};

class App extends Component {
  static propTypes = {
    original: PropTypes.instanceOf(HTMLElement)
  };
  constructor (props) {
    super(props);
    this.state = { value: 1, original: props.original };
  }
  // componentDidMount () {}
  render () {
    const self = this;
    return (
      <OriginalContext.Provider value={self.props.original}>
        <Router>
          <div>
            <Switch>
              <Route exact path={root} component={Home} />
              <Route path={config.path.reference_certificate} component={Certification} />
              <Route path={config.path.open_complete} component={OpenComplete} />
              <Route path={config.path.close_complete} component={CloseComplete} />
              <Route path={config.path.change_complete} component={ChangeComplete} />
              <Route path={config.path.cancel_complete} component={CancelComplete} />
              <Route path={config.path.open} component={OpenInput} />
              <Route path={config.path.close} component={CloseInput} />
              <Route path={config.path.reference} component={Reference} />
              <Route path={config.path.change} component={Change} />
              <Route component={NotFound} />
            </Switch>
          </div>
        </Router>
      </OriginalContext.Provider>
    );
  }
}

export default App;
